import useStyles  from "_styles/atoms/buttons/textButton";
import React      from "react";
import BaseButton from "./baseButton";

const TextButton = ( {
	key,
	className,
	onClick = () => {},
	startIcon,
	endIcon,
	size = "normal",
	active,
	label,
	fullWidth,
	fontWeight = "normal",
	buttonTextClassName,
	color,
	disabled = false,
	children
} ) => {

	const { classes } = useStyles ( { size, active, fullWidth, fontWeight, color, disabled } );

	return (
		<BaseButton
			key                  = { key }
			buttonTextClassName  = { buttonTextClassName }
			className            = { className }
			defaultClassName     = { classes.textButton }
			defaultTextClassName = { classes.buttonText }
			disabled             = { disabled }
			endIcon              = { endIcon }
			onClick              = { onClick }
			startIcon            = { startIcon }
			title                = { label || children }
			variant = "subtle"
		/>
	);
};

export default TextButton;
